import React, { useState, useEffect } from 'react'

import * as StringFormatter from '../../../../global/formatters/string-formatter.js'
import { getRelativeBasePath } from '../../../../global/environments/path.js'
import { isInvestor } from '../../../../global/authentication/authentication-manager.js'
import { encodeForURL } from '../../../../global/formatters/string-formatter.js'
import DOMPurify from 'dompurify'
import { removeSpecialCharacters } from '../../../utility/strings/strings.js'

import {
  getMutualFundData,
  get529Data,
  getVariableFundsData,
  getClosedEndFundsData,
  getExchangeTradedFundsData,
} from '../InvestmentProductsDataSource.js'

import PageHeader from '../../../../components/PageHeader/PageHeader.jsx'
import { Table } from '../../table/table.jsx'

export default function SearchList() {
  const IS_INVESTOR = isInvestor()

  const [funds, setFunds] = useState([])
  const [selectedType, setSelectedType] = useState('')
  const [selectedClass, setSelectedClass] = useState('')
  const [selectedAspect, setSelectedAspect] = useState()

  const getAspect = (section) => {
    const aspects = [
      {
        name: '#mutual-funds',
        info: {
          tag: 'Monthly',
          selector: [
            {
              name: 'value',
              isArray: false,
            },
            {
              name: 'mutualFunds',
              isArray: false,
            },
            {
              name: 'performanceFunds',
              isArray: false,
            },
          ],
          getData: getMutualFundData,
          columns: [
            {
              name: 'fundName',
              content: <>Name</>,
              cell: {
                className: 'u-paddingLeft5gu',
                content: (fund) => (
                  <a
                    className="u-textBold u-textUppercase u-sm-textNone"
                    href={DOMPurify.sanitize(
                      encodeForURL(
                        getRelativeBasePath() +
                          `/investment-products/mutual-funds/${StringFormatter.urlSafe(
                            removeSpecialCharacters(fund.fundName)
                          )}/Class-${selectedClass}/details/?cusip=${
                            fund.cusip
                          }`
                      )
                    )}
                  >
                    {fund.fundName}
                  </a>
                ),
              },
            },
          ],
        },
      },
      {
        name: '#529-funds',
        info: {
          tag: 'Monthly',
          selector: [
            {
              name: 'value',
              isArray: false,
            },
            {
              name: 'products',
              isArray: false,
            },
          ],
          getData: get529Data,
          parseData: parseDataTarget,
          columns: [
            {
              name: 'fundName',
              className: 'Table-header',
              ariaLabel: 'Name',
              content: <>Name</>,
              cell: {
                className: 'u-paddingLeft5gu',
                content: (fund) => (
                  <a
                    className="u-textBold u-textUppercase u-sm-textNone"
                    href={encodeForURL(
                      `${getRelativeBasePath()}/investment-products/529-plan/${StringFormatter.urlSafe(
                        removeSpecialCharacters(fund.name)
                      )}/Class-${selectedClass}/details/?cusip=${fund.cusip}`
                    )}
                  >
                    {fund.name}
                  </a>
                ),
              },
            },
          ],
        },
      },
      {
        name: '#variable-funds',
        info: {
          tag: 'Monthly',
          selector: [
            {
              name: 'value',
              isArray: false,
            },
            {
              name: 'variableProducts',
              isArray: false,
            },
          ],
          getData: getVariableFundsData,
          parseData: parseDataVariable,
          columns: [
            {
              name: 'fundName',
              className: 'Table-header',
              ariaLabel: 'Name',
              content: <>Name</>,
              cell: {
                className: 'u-paddingLeft5gu',
                content: (fund) => (
                  <a
                    className="u-textBold u-textUppercase u-sm-textNone"
                    href={DOMPurify.sanitize(
                      encodeForURL(
                        getRelativeBasePath() +
                          `/investment-products/variable-products/${StringFormatter.urlSafe(
                            removeSpecialCharacters(fund.name)
                          )}/Class-${selectedClass}/details/?cusip=${
                            fund.cusip
                          }`
                      )
                    )}
                  >
                    {fund.name}
                  </a>
                ),
              },
            },
          ],
        },
      },
      {
        name: '#closed-end-funds',
        info: {
          tag: 'Monthly',
          selector: [
            {
              name: 'value',
              isArray: false,
            },
            {
              name: 'closedEndFunds',
              isArray: false,
            },
          ],
          getData: getClosedEndFundsData,
          columns: [
            {
              name: 'fundName',
              className: 'Table-header',
              ariaLabel: 'Name',
              content: <>Name</>,
              cell: {
                className: 'u-paddingLeft5gu',
                content: (fund) => (
                  <a
                    className="u-textBold u-textUppercase u-sm-textNone"
                    href={encodeForURL(
                      getRelativeBasePath() +
                        `/investment-products/closed-end-funds/${StringFormatter.urlSafe(
                          removeSpecialCharacters(fund.fundName)
                        )}/Class-None/details/?cusip=${fund.cusip}`
                    )}
                  >
                    {fund.fundName}
                  </a>
                ),
              },
            },
          ],
        },
      },
      {
        name: '#etf-funds',
        info: {
          tag: 'ETF',
          selector: [
            {
              name: 'funds',
              isArray: false,
            },
          ],
          getData: getExchangeTradedFundsData,
          preProcessData: preProcessData,
          columns: [
            {
              name: 'fundName',
              className: 'Table-header',
              ariaLabel: 'Name',
              content: <>Name</>,
              cell: {
                className: 'u-paddingLeft5gu',
                content: (fund) => (
                  <a
                    className="u-textBold u-textUppercase u-sm-textNone"
                    href={DOMPurify.sanitize(
                      encodeForURL(
                        getRelativeBasePath() +
                          `/investment-products/exchange-traded-funds/${StringFormatter.urlSafe(
                            removeSpecialCharacters(fund.fundName)
                          )}/Class-${selectedClass}/details/?cusip=${
                            fund.classes[0].cusip
                          }`
                      )
                    )}
                  >
                    {fund.fundName}
                  </a>
                ),
              },
            },
          ],
        },
      },
    ]

    return aspects.find((a) => a.name === section).info
  }

  useEffect(() => {
    if (funds && funds.length > 0) {
      window.prerenderReady = true
    }
  }, [funds])

  useEffect(() => {
    initializeFunds()
  }, [selectedAspect])

  useEffect(() => {
    let _aspect

    switch (selectedType) {
      case 'mutualFunds':
        _aspect = getAspect('#mutual-funds')

        break
      case '529':
        _aspect = getAspect('#529-funds')

        break
      case 'variable':
        _aspect = getAspect('#variable-funds')

        break
      case 'closedend':
        _aspect = getAspect('#closed-end-funds')

        break
      case 'etf':
        _aspect = getAspect('#etf-funds')

        break
    }

    setSelectedAspect(_aspect)
  }, [selectedType])

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)

    const _type = urlParams.get('type')

    if (_type) {
      setSelectedType(_type)

      const _class = urlParams.get('class')

      if (_class) {
        setSelectedClass(_class)
      }
    }
  }, [])

  const initializeFunds = async () => {
    const aspect = selectedAspect

    if (!aspect) {
      return
    }

    let _data = await aspect.getData(aspect.tag, selectedClass)

    if (aspect.preProcessData) {
      _data = aspect.preProcessData(_data)
    }

    let _funds = aspect.selector.reduce(
      (prev, curr) => (curr.isArray ? prev[curr.name][0] : prev[curr.name]),
      _data
    )

    if (aspect.parseData) {
      _funds = aspect.parseData(_funds)
    }

    _funds = _funds.sort((a, b) =>
      (a.fundName || a.name || '').localeCompare(
        b.fundName || b.name || '',
        'en',
        { sensitivity: 'base' }
      )
    )

    setFunds(_funds)
  }

  const preProcessData = (data) => {
    const _data = { funds: [] }

    data.value.products.forEach((item) => {
      item.funds.forEach((fundItem) => {
        _data.funds.push(fundItem)
      })
    })

    return _data
  }

  const parseDataTarget = (funds) => {
    return funds.filter((f) => f.name.indexOf('Columbia 529') < 0)
  }

  const parseDataVariable = (funds) => {
    return funds.filter((f) => f.className.trim() === selectedClass)
  }

  const aspect = selectedAspect

  return (
    <div className="investment-products">
      <PageHeader title="Product List" />
      <div className="u-paddingVert2gu u-bgColorLight">
        <div className="u-sizeConstrained Card Content u-paddingBottom15gu u-marginBottom10gu">
          <div className="u-textBold u-textUppercase u-paddingVert3gu">
            List of mutual funds
          </div>
          <ul>
            <li>
              <a
                href={
                  getRelativeBasePath() +
                  `/investment-products/search-list/?type=mutualFunds&class=A`
                }
              >
                Mutual Funds Class A
              </a>
            </li>
            <li>
              <a
                href={
                  getRelativeBasePath() +
                  `/investment-products/search-list/?type=mutualFunds&class=C`
                }
              >
                Mutual Funds Class C
              </a>
            </li>
            <li>
              <a
                href={
                  getRelativeBasePath() +
                  `/investment-products/search-list/?type=mutualFunds&class=R`
                }
              >
                Mutual Funds Class R
              </a>
            </li>
            <li>
              <a
                href={
                  getRelativeBasePath() +
                  `/investment-products/search-list/?type=mutualFunds&class=V`
                }
              >
                Mutual Funds Class V
              </a>
            </li>
            <li>
              <a
                href={
                  getRelativeBasePath() +
                  `/investment-products/search-list/?type=mutualFunds&class=Advisor`
                }
              >
                Mutual Funds Class Advisor
              </a>
            </li>
            <li>
              <a
                href={
                  getRelativeBasePath() +
                  `/investment-products/search-list/?type=mutualFunds&class=Institutional`
                }
              >
                Mutual Funds Class Institutional
              </a>
            </li>
            <li>
              <a
                href={
                  getRelativeBasePath() +
                  `/investment-products/search-list/?type=mutualFunds&class=Institutional2`
                }
              >
                Mutual Funds Class Institutional2
              </a>
            </li>
            <li>
              <a
                href={
                  getRelativeBasePath() +
                  `/investment-products/search-list/?type=mutualFunds&class=Institutional3`
                }
              >
                Mutual Funds Class Institutional3
              </a>
            </li>
          </ul>
          <div className="u-textBold u-textUppercase u-paddingVert3gu">
            List of 529 Plans
          </div>
          <ul>
            <li>
              <a
                href={
                  getRelativeBasePath() +
                  `/investment-products/search-list/?type=529&class=A`
                }
              >
                529 Funds Class A
              </a>
            </li>
            <li>
              <a
                href={
                  getRelativeBasePath() +
                  `/investment-products/search-list/?type=529&class=C`
                }
              >
                529 Funds Class C
              </a>
            </li>
            <li>
              <a
                href={
                  getRelativeBasePath() +
                  `/investment-products/search-list/?type=529&class=E`
                }
              >
                529 Funds Class E
              </a>
            </li>
            <li>
              <a
                href={
                  getRelativeBasePath() +
                  `/investment-products/search-list/?type=529&class=I`
                }
              >
                529 Funds Class I
              </a>
            </li>
          </ul>
          <div className="u-textBold u-textUppercase u-paddingVert3gu">
            List of Variable Products
          </div>
          <ul>
            <li>
              <a
                href={
                  getRelativeBasePath() +
                  `/investment-products/search-list/?type=variable&class=1`
                }
              >
                Variable Funds Class 1
              </a>
            </li>
            <li>
              <a
                href={
                  getRelativeBasePath() +
                  `/investment-products/search-list/?type=variable&class=2`
                }
              >
                Variable Funds Class 2
              </a>
            </li>
            <li>
              <a
                href={
                  getRelativeBasePath() +
                  `/investment-products/search-list/?type=variable&class=3`
                }
              >
                Variable Funds Class 3
              </a>
            </li>
            <li>
              <a
                href={
                  getRelativeBasePath() +
                  `/investment-products/search-list/?type=variable&class=`
                }
              >
                Variable Funds Shares
              </a>
            </li>
          </ul>
          <div className="u-textBold u-textUppercase u-paddingVert3gu">
            List of Closed-End Funds
          </div>
          <ul>
            <li>
              <a
                href={
                  getRelativeBasePath() +
                  `/investment-products/search-list/?type=closedend`
                }
              >
                Closed-End Funds
              </a>
            </li>
          </ul>
          <div className="u-textBold u-textUppercase u-paddingVert3gu">
            List of ETFs
          </div>
          <ul>
            <li>
              <a
                href={
                  getRelativeBasePath() +
                  `/investment-products/search-list/?type=etf`
                }
              >
                ETF Funds
              </a>
            </li>
          </ul>
          {!IS_INVESTOR && (
            <>
              <div className="u-textBold u-textUppercase u-paddingVert3gu">
                Managed Account Funds
              </div>
              <ul>
                <li>
                  <a
                    href={
                      getRelativeBasePath() +
                      `/investment-products/managed-accounts/`
                    }
                  >
                    Managed Accounts
                  </a>
                </li>
              </ul>
            </>
          )}
          <div className="u-textBold u-textUppercase u-paddingVert3gu">
            Links to the Funds
          </div>
          {aspect && funds && (
            <Table
              columns={aspect.columns}
              rows={funds}
              mode="no-header no-stripe"
            />
          )}
        </div>
      </div>
    </div>
  )
}
